// extracted by mini-css-extract-plugin
export default {"input":"insert-attachment_input__o2FGX"};